import React from 'react';
import { Button, Box, Grid } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { ReactComponent as GoToIcon } from '../../admissions/components/icons/right-long-arrow.svg';
import { styles } from './styles';

const DashBoard = () => {
  const theme = useTheme();
  const classes = styles(theme);

  const ariaLabel = 'Maintenance Control Page';
  const id = 'go-to-maintenence';
  const hrefLink = '/admin/maintenance';
  const label = 'Go to Maintenance Admin';

  const handleClick = () => {

  };

  return (
    <>
      <h1> Welcome Admin! </h1>

      <Grid
        size={12}
        sx={classes.backBtnContainer}
      >
        <Box sx={classes.gotoBtnBox}>
          <Button
            id={id}
            role="link"
            aria-label={ariaLabel}
            className="pageBackBtn"
            onClick={handleClick}
            endIcon={(
              <GoToIcon
                aria-hidden
                style={classes.gotoIcon}
              />
            )}
            href={hrefLink}
          >
            {label}
          </Button>
        </Box>
      </Grid>
    </>
  );
};

export default DashBoard;